import React, { Fragment } from "react";

import banner12 from "../../assets/images/banner12.png";
import banner2 from "../../assets/images/banner2.jpg";
import { ButtonLink } from "../../components/ButtonLink/ButtonLink";
import { ConsultationBanner } from "../../components/ConsultationBanner/ConsultationBanner";
import { FAQSection } from "../../components/FAQSection/FAQSection";
import { OutcomeSection } from "../../components/OutcomeSection/OutcomeSection";
import { ResultSection } from "../../components/ResultSection/ResultSection";
import { ReviewSection } from "../../components/ReviewSection/ReviewSection";
import { ServiceBannerSection } from "../../components/ServiceBannerSection/ServiceBannerSection";
import { TargetAudienceSection } from "../../components/TargetAudienceSection/TargetAudienceSection";
import { TariffSection } from "../../components/TariffSection/TariffSection";
import { WorkflowSection } from "../../components/WorkflowSection/WorkflowSection";
import { faqData } from "../../config/faqData";
import { outcomeData } from "../../config/outcomeData";
import { resultData } from "../../config/resultData";
import { targetAudienceData } from "../../config/targetAudienceData";
import { workflowData } from "../../config/workflowData";
import { usePageData } from "../../hooks/usePageData";
import {
  Section,
  SmallTitle,
  TitleH2,
} from "../../styles/sharedStyles";

import {
  CareerAuditFAQScope,
  Container,
  CustomTitleH2,
} from "./styles"

const target = targetAudienceData.career_audit_page
const workflow = workflowData.career_audit_page
const result = resultData.career_audit_page
const faq = faqData.career_audit_page
const { outcome, backgroundImage } = outcomeData.career_audit_page

export const CareerAudit = () => {
  const { card, productCategories, reviews: filteredReviews } = usePageData(8);

  const filteredProducts = card.filter(
    (item) => item.product_category.id === 20
  );

  return (
    <Fragment>
      <ServiceBannerSection
        mainText="Карьерный аудит 360"
        backgroundImage={banner12}
        descText="Полная профессиональная оценка вашего уровня, экспертизы
         и точек роста – как вас видит рынок, и что делать дальше."
        buttonTitle="Написать в Телеграм"
      />
      <Section>
        <Container>
          <CustomTitleH2>Кому подходит <span>Карьерный аудит 360 ?</span></CustomTitleH2>
          <TargetAudienceSection data={target} />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Как строится работа?</TitleH2>
          <WorkflowSection data={workflow} />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Что вы получите <span>в итоге ?</span></TitleH2>
          <OutcomeSection
            data={outcome}
            backgroundImage={backgroundImage}
          />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Мы приносим <span>результат</span></TitleH2>
          <ResultSection data={result} />
        </Container>
      </Section>
      <Section>
        <Container>
          <SmallTitle>тарифы</SmallTitle>
          <TitleH2>Как мы можем помочь</TitleH2>
          <TariffSection
            products={filteredProducts}
            color="#94D4FF"
          />
        </Container>
      </Section>
      {filteredReviews.length > 0 && (
        <Section>
          <Container>
            <TitleH2>Отзывы</TitleH2>
            <ReviewSection
              reviews={filteredReviews}
              categories={productCategories}
            />
            <ButtonLink
              toPage="/reviews"
              title="Все отзывы"
            />
          </Container>
        </Section>
      )}
      <ConsultationBanner
        backgroundImage={banner2}
        buttonTitle="Написать в Телеграм"
      />
      <Section>
        <Container>
          <CareerAuditFAQScope>
            <FAQSection data={faq} />
          </CareerAuditFAQScope>
        </Container>
      </Section>
    </Fragment>
  )
}
